import request from '@/config/request'

export default {
    searchStoredCardForAll: function (customerCode) {
        return request({
            url: '/asset/mycard/searchstoredcardforall',
            method: 'post',
            params: {
                customercode: customerCode,
            }
        })
    },

    searchStoredCardForNormal: function (customerCode) {
        return request({
            url: '/asset/mycard/searchstoredcardfornormal',
            method: 'post',
            params: {
                customercode: customerCode,
            }
        })
    },

    searchStoredCardForFreeze: function (customerCode) {
        return request({
            url: '/asset/mycard/searchstoredcardforfreeze',
            method: 'post',
            params: {
                customercode: customerCode,
            }
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/asset/mycard.js